import React from 'react';
import { AlertTriangle, Edit2, Eye, Loader2, Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { fFecha, SEVERIDAD } from './episodioUtils';

// Casos viejos con alertas vinculadas por id (sin episodios embebidos): lista compacta.
export const CasoAlertasVinculadas = ({ alertas, loading, onVer, onResolver, onQuitar, onAgregar }) => (
  <div data-testid="caso-alertas-vinculadas">
    <div className="mb-3 flex items-center justify-between">
      <p className="text-sm text-slate-600">Alertas vinculadas a este caso (caso anterior al motor de episodios).</p>
      <Button size="sm" variant="outline" onClick={onAgregar} className="gap-1" data-testid="alertas-vinculadas-agregar"><Plus size={14} /> Agregar alerta</Button>
    </div>
    {loading ? <div className="flex justify-center py-8"><Loader2 className="animate-spin text-slate-400" size={22} /></div>
      : alertas.length === 0 ? (
        <div className="flex flex-col items-center py-10 text-slate-400"><AlertTriangle size={32} className="mb-2" /><p className="text-sm">No hay alertas vinculadas</p></div>
      ) : (
        <ol className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
          {alertas.map((a) => (
            <li key={a.id} className="flex items-center gap-3 px-3 py-2.5 text-sm" data-testid={`alerta-vinculada-${a.id}`}>
              <span className={`rounded px-1.5 py-0.5 text-[9px] font-bold uppercase ${SEVERIDAD[a.severidad] || 'bg-slate-200'}`}>{a.severidad}</span>
              <span className="min-w-0 flex-1 truncate font-medium text-slate-800">{a.titulo}</span>
              <span className="text-xs text-slate-500">{(a.estado || 'NUEVA').replace('_', ' ')}</span>
              <span className="font-mono text-xs text-slate-400">{fFecha(a.fecha_creacion || a.created_at)}</span>
              <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => onVer(a.id)} title="Ver detalle"><Eye size={13} /></Button>
              <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => onResolver(a)} title="Cambiar estado"><Edit2 size={13} /></Button>
              <button type="button" onClick={() => onQuitar(a.id)} className="rounded p-1 text-red-500 hover:bg-red-50" title="Desvincular"><Trash2 size={13} /></button>
            </li>
          ))}
        </ol>
      )}
  </div>
);

export default CasoAlertasVinculadas;
